module.exports = __webpack_public_path__ + "static/logo-23f517c6e57f54e17fd0730d1960d327.png";